"use client";
import Image from "next/image";
import {
  Box,
  Flex,
  Heading,
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
} from "@chakra-ui/react";
import { useSectionHeadingVariant } from "@/theme/components/useSectionHeading";
import { BAREMETAL_SERVER_DATA } from "./constants";
import PricingFooter from "./pricingfooter";

const PricingTable = () => {
  const HeadingVariant = useSectionHeadingVariant();
  return (
    <Box id="pricing">
      <Heading variant={HeadingVariant} textAlign={"center"} mb={8}>
        Bare-Metal Server Pricing
      </Heading>
      <TableContainer>
        <Table variant="striped" border={"2px solid rgb(237,242,247)"}>
          <Thead>
            <Tr>
              <Th>CPU</Th>
              <Th>Memory</Th>
              <Th>Base Clock | Boost</Th>
              <Th>Disk</Th>
              <Th>Boot Drives</Th>
              <Th>Price</Th>
            </Tr>
          </Thead>
          <Tbody>
            {BAREMETAL_SERVER_DATA.map((data, index) => {
              return (
                <Tr key={index}>
                  <Td>
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      flexDirection={"row"}
                      gap={"6px"}
                    >
                      <Box
                        h="2rem"
                        position="relative"
                        w="2rem"
                        display={"flex"}
                        alignItems={"center"}
                        gap="2px"
                      >
                        <Image
                          src={data.image}
                          alt="image"
                          style={{ objectFit: "contain" }}
                        />
                      </Box>
                      <Flex direction={"column"} style={{ whiteSpace: "nowrap" }}>
                        <Box>{data.processor}</Box>
                        <Box style={{ fontSize: "14px", color: "gray.500" }}>
                          {data.sku}
                        </Box>
                      </Flex>
                    </Box>
                  </Td>
                  <Td>
                    <Text>{data.memory}</Text>
                  </Td>
                  <Td>
                    <Text>{data.baseclock_boost}</Text>
                  </Td>
                  <Td>
                    <Text>{data.disk}</Text>
                  </Td>
                  <Td>
                    <Text>{data.bootDrives}</Text>
                  </Td>
                  <Td>
                    <Text>{data.price}</Text>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableContainer>
      <PricingFooter />
    </Box>
  );
};

export default PricingTable;
